module.exports = __webpack_public_path__ + "img/1440.e9bf0d03.jpg";